export default __webpack_public_path__ + "static/media/libation_library_logo_v1.93c7cdfb.svg";